module.exports = __webpack_public_path__ + "img/dropsSlots_460.6da6340c.png";